import styled from 'styled-components';

const Main = styled.form``;

const Bottom = styled.div`
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
`;

const FormButton = styled.div`
  display: flex;
  gap: var(--space-12);
  align-items: flex-end;
  justify-content: flex-end;
`;

export { Main, Bottom, FormButton };
